import type { FaireProductEntity } from "../../entity_types/product";

export const p_6sjkvyqf4h: FaireProductEntity = {
  token: "p_6sjkvyqf4h",
  type: "product",
  name: "Bath Bomb – 5 oz",
  brandToken: "b_84s66t3hhw",
  brandName: "Suzy Spa Essentials",
  imageUrl:
    "https://cdn.faire.com/fastly/b7d5a1604cca41c0746d2d2bde3130efbbbeb589ce8f6bb2f7c033bb0a05d90a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f7f011e55fba6e1578d669c1cdea0dc00e1068779f1cebd0ee7d3b374cde1fc.jpeg",
    "https://cdn.faire.com/fastly/bef6be88fdcfbd7dae7dcacb4c6e5dd192768d05dbaa05a937a3a968c0ee9e49.jpeg",
    "https://cdn.faire.com/fastly/1140841ddc9014ba98a03d83393316c22a3fb8f38a610b72edfdb16ebf567682.jpeg",
    "https://cdn.faire.com/fastly/7ba9d5a76a63307de70b8b23e7a77b54343dcb35ca6782b3c1808c46cc32b397.jpeg",
    "https://cdn.faire.com/fastly/a54306fd4e1e84c2d3786b92c367777f025324a58f4e330f6545ac8323d22ee1.jpeg",
    "https://cdn.faire.com/fastly/786ae797a6f60768ef2c64914b1c1c2da7d22ca2280c920df775924513580961.jpeg",
    "https://cdn.faire.com/fastly/2c8a3f803f5a98641fd0bb935f4b4bc9e563df63d20b67cb0bf2e61cd14b4b49.jpeg",
    "https://cdn.faire.com/fastly/94ac7b99022d4ad08e7ffbaceb40bc6ff19ccddf626aad50bc4b856574f44817.jpeg",
    "https://cdn.faire.com/fastly/ab506e965abd3b8b762f177438070fca21d581ca277b70b0589d4dda5b763f47.jpeg",
    "https://cdn.faire.com/fastly/3371f60dd1ff4ee38c9df7be1004caecb73b9bb4a5b07989803c0e5d11c29c9e.jpeg",
    "https://cdn.faire.com/fastly/294baed478d2a731cc5e421aef6fe01221d17c4e4631fa9e16b225a6d364da02.jpeg",
    "https://cdn.faire.com/fastly/789729310ef12b8f3a3d907fda13dfb90a29fb684f493412ecce02a6bb79fe49.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Treat yourself to a spa-worthy soak with our handcrafted 5 oz bath bombs, made in small batches using all-natural ingredients. Each bomb is infused with skin-softening oils, Epsom salts, and pure essential oils to calm your senses and promote relaxation.\n\n• 100% natural, handmade with care\n• Soothes muscles, softens skin, and enhances relaxation\n• Enhanced with dried botanicals or oatmeal depending on scent\n• Beautifully shrink-wrapped and labeled for retail display\n• 5 oz size – perfect as a self-care treat or gift",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:18.808Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
